import { useEffect } from "react";
import { useRunCommand } from "@/lib/commands/CommandProvider";

type ElectronApi = {
  onMenuCommand?: (cb: (commandId: string) => void) => () => void;
};

/**
 * Subscribes to menu / dock / tray command events from the desktop shell and
 * dispatches them through the command registry. No-op outside the desktop
 * runtime (web build has no electron bridge).
 *
 * Must be mounted once inside `CommandProvider`, alongside
 * `useCommandShortcuts`.
 */
export function useMenuCommandListener(): void {
  const run = useRunCommand();

  useEffect(() => {
    const api = (window as unknown as { __electronApi?: ElectronApi })
      .__electronApi;
    if (!api?.onMenuCommand) return;
    return api.onMenuCommand((id) => run(id));
  }, [run]);
}
